<template>
  <div class="main-body">
    <div class="header">智能手表</div>
    <div class="out">
      <div class="search2">

        <div style="float:right">

          <el-input v-model="userName" placeholder="选择老人" disabled style="width: 250px;margin-right: 10px;">
            <el-button slot="append" icon="el-icon-search" @click="getElderly"></el-button>
            <el-button slot="prepend" icon="el-icon-close" @click="clearElderly"></el-button>
          </el-input>

          <el-input size="mini"  placeholder="输入Imei号" v-model="imeiAll" clearable style="margin-right:10px;width:180px"></el-input>

          <el-button size="mini" type="primary" icon="el-icon-search" @click="getList(true)">搜索</el-button>
        </div>

        <div style="clear: both;"></div>
      </div>


      <el-table class="table" size="mini" v-loading="tableLoading"  :data="tableData" :height="th" border style="width: 100%;">
        <el-table-column prop="userName" label="用户名" width="100" fixed></el-table-column>
        <el-table-column prop="phone" label="手机号" width="150"></el-table-column>
        <el-table-column prop="imeiAll" label="Imei号" width="180"></el-table-column>
        <el-table-column prop="battery" label="电量" width="100"></el-table-column>
        <el-table-column prop="onLine2" label="在线状态" width="100">
          <template slot-scope="scope">
            <span v-if="scope.row.onLine2 == true">在线</span>
            <span v-if="scope.row.onLine2 == false" style="color: red;">离线</span>
          </template>
        </el-table-column>

        <el-table-column prop="zoneCodePathName" label="所在区域" width="300" ></el-table-column>

        <el-table-column prop="createTime" label="绑定时间" :formatter="timefilter" min-width="150"></el-table-column>

        <el-table-column fixed="right" label="操作" width="100px">
          <template slot-scope="scope">
            <el-button type="success" size="mini" @click="getWatchData(scope.$index, scope.row)" >数据</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）</div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change"
          ></el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>


    <Elderly ref="myElderly" v-show="showModalGetElderly" v-on:closeElderly="showModalGetElderly=false" v-on:setElderly="setElderly"></Elderly>


    <WatchData ref="WatchData"  v-show="watchDataShow"  v-on:closeWatchData="closeWatchData"></WatchData>

  </div>
</template>

<script>

import { timeStr,timefilters } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getGovernmentCode } from "@/utils/auth";

import WatchData from "../Comm/Data/WatchData";

import Elderly from "@/views/Elderly/Comm/ElderlyGov";


export default {
  name: "Role",
  data() {
    return {
      tableLoading:false,

      showModalAdd:false,
      showModalSOSSetPage:false,
      watchDataShow:false,

      showModalGetElderly:false,

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,

      th: 0,

      userCode: "",
      userName:'',
      imeiAll: "",



    };
  },
  components:{
    WatchData,Elderly
  },
  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },

  watch: {
    //监听全局变量
    "$store.state.tableHeight": function (val) {
      this.th = val;
    },
  },
  methods: {
    init: function () {

    },


    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },


    getElderly(){
      this.showModalGetElderly = !this.showModalGetElderly;
      this.$refs.myElderly.init();
    },
    setElderly(row){
      this.userCode = row.userCode;
      this.userName = row.name;
    },
    clearElderly(){
      this.userCode = '';
      this.userName = '';
    },



    getWatchData(index,row){
      this.$refs.WatchData.init(row);
      this.watchDataShow =!this.watchDataShow;
    },
    closeWatchData(){
      this.watchDataShow =!this.watchDataShow;
    },

    setData(index,row){
      this.$refs.mySOSSetPage.init(row);
      this.showModalSOSSetPage = !this.showModalSOSSetPage;
    },
    closeSOSSetPage(){
      this.showModalSOSSetPage =!this.showModalSOSSetPage;
    },


    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1
      this.tableLoading=true

      this.$axios({
        method: "post",
        url: this.$deviceUrl + "DeviceXiaodou/GovPage",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          governmentCode:getGovernmentCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
          userCode: this.userCode,
          imeiAll: this.imeiAll,
        },
      }).then((response) => {
        this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message.error(response.data.message);
        }
      }).catch(function (error) {
            this.tableLoading=false
            console.log(error);
          });
    },


    timefilter(row, column, cellValue) {
      return timefilters(cellValue);
    },


  },
};
</script>

<style scoped>
</style>
